import z from "zod";

export const partnerSendReportFormSchema = z.object({
	recipients: z.array(z.email()),
	sendCopyToCreator: z.boolean(),
});

export type PartnerSendReportFormSchema = z.infer<typeof partnerSendReportFormSchema>;
